import { MaintenanceState } from "@badorbad/shared";
import { useMaintenance } from "../design/useMaintenance";
import { palette } from "../design/tokens";
import { t, fmt } from "../locale";

/**
 * The maintenance banner, above every screen.
 *
 * It is a flex sibling of the router rather than an overlay, so it pushes the
 * app down and shrinks it instead of covering the top of whatever is
 * underneath. The total stays one viewport with nothing to scroll — which
 * matters most on the split, where a covered edge would hide an option.
 */

const mmss = (ms: number): string => {
  const total = Math.max(Math.ceil(ms / 1000), 0);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
};

export const MaintenanceBanner = () => {
  const { state, remainingMs } = useMaintenance();

  if (state === MaintenanceState.Off) return null;

  const draining = state === MaintenanceState.Draining;

  return (
    <div
      role="status"
      className="shrink-0 px-4 py-2 text-center text-xs font-bold leading-snug"
      style={{
        // Rust, not gold: gold means "option one" on the very next screen.
        backgroundColor: palette.sideB,
        color: palette.ink,
      }}
    >
      {draining
        ? fmt(t.connection.maintenanceDraining, mmss(remainingMs))
        : t.connection.maintenanceActive}
    </div>
  );
};
